<template>
<div class="chapter">
<div class="inner_page">
<div class="part">
<h1 class="part" id="p01"><a id="page17"></a><span href="#/OEBPS/toc#pt01" title="Link target outside of Sample">PART ONE</span></h1>
<p class="center">“During the last thousand years, a Sassoon<br/> has never been known to be wrong.”<br/><br/></p>
<p class="center">– Ernest O. Hauser,</p>
<p class="center">“The Fabulous Sassoons,”</p>
<p class="center"><em>The American Mercury</em>, 1940.</p>
<p class="comm"><img alt="" src="OEBPS/images/comm1.jpg"/><a id="page18"></a></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// p01.vue?e8c303aa